"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _underscore = require("FileManagerCore/vendor/underscore.custom");

var _Constants = require("FileManagerLib/Constants");

var _AnimatedCollection = _interopRequireDefault(require("./AnimatedCollection"));

var getDetailsTileCellNumber = (0, _underscore.memoize)(function (tiles) {
  return tiles.reduce(function (cellNumber, tile, index) {
    if (tile.get('type') === _Constants.CellTypes.FILE_DETAIL) {
      return index;
    }

    return cellNumber;
  }, -1);
});
var tileBeforeDetails = 0;

var getScrollToCellNumber = function getScrollToCellNumber(tiles) {
  var detailsTileCellNumber = getDetailsTileCellNumber(tiles);
  if (detailsTileCellNumber === -1) return tileBeforeDetails;
  tileBeforeDetails = detailsTileCellNumber - 1;
  return detailsTileCellNumber;
};

var Tiles =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tiles, _Component);

  function Tiles(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tiles);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tiles).call(this, props));
    _this.renderCell = _this.renderCell.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSectionRendered = _this.handleSectionRendered.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCellSizeAndPosition = _this.getCellSizeAndPosition.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Tiles, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.tiles !== this.props.tiles) {
        this._collection.recomputeCellSizesAndPositions();
      }
    }
  }, {
    key: "getCellSizeAndPosition",
    value: function getCellSizeAndPosition(_ref) {
      var index = _ref.index;
      var tiles = this.props.tiles;
      var tile = tiles.get(index);
      return {
        height: tile.get('height'),
        width: tile.get('width'),
        x: tile.get('x'),
        y: tile.get('y')
      };
    }
  }, {
    key: "handleSectionRendered",
    value: function handleSectionRendered(_ref2) {
      var indices = _ref2.indices;
      var onRowsRendered = this.props.onRowsRendered;

      if (onRowsRendered) {
        onRowsRendered({
          startIndex: indices[0],
          stopIndex: indices[indices.length - 1]
        });
      }
    }
  }, {
    key: "renderCell",
    value: function renderCell(_ref3) {
      var index = _ref3.index,
          key = _ref3.key,
          style = _ref3.style;
      var _this$props = this.props,
          tiles = _this$props.tiles,
          tileRenderer = _this$props.tileRenderer;
      var tile = tiles.get(index);
      return _react.default.createElement("div", {
        key: key,
        style: style
      }, tileRenderer(tile));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          tiles = _this$props2.tiles,
          height = _this$props2.height,
          width = _this$props2.width;
      return _react.default.createElement(_AnimatedCollection.default, {
        refAnimatedCollection: function refAnimatedCollection(c) {
          _this2._collection = c;
        },
        className: "tiles",
        height: height,
        width: width,
        tiles: tiles,
        cellCount: tiles.size,
        cellRenderer: this.renderCell,
        cellSizeAndPositionGetter: this.getCellSizeAndPosition,
        onSectionRendered: this.handleSectionRendered,
        verticalOverscan: 8,
        scrollToCell: getScrollToCellNumber(tiles)
      });
    }
  }]);
  return Tiles;
}(_react.Component);

exports.default = Tiles;
Tiles.propTypes = {
  height: _react.PropTypes.number.isRequired,
  width: _react.PropTypes.number.isRequired,
  tiles: _react.PropTypes.instanceOf(_immutable.default.List).isRequired,
  tileRenderer: _react.PropTypes.func.isRequired,
  onRowsRendered: _react.PropTypes.func
};
module.exports = exports.default;